import { useAltezzaPubblicata } from './useAltezzaPubblicata';

/** Il nome della variabile scritta su `:root`. Il ripiego sta in index.css. */
const VARIABILE = '--altezza-banda-gara';

/**
 * Quanto e' alto il banner «gara in corso», detto alle pagine.
 *
 * Serve alle riserve di spazio in fondo alle pagine: il banner e' `fixed` e non
 * occupa flusso, quindi senza questa misura l'ultima riga di una pagina gli
 * finisce sotto e non c'e' modo di scorrerla. Prima non si notava perche' il
 * banner stava sopra la banda dei bottoni — cioe' copriva un'altra cosa invece
 * del testo.
 *
 * La misura, non un numero: il titolo del banner va a capo nelle lingue lunghe,
 * ed e' lo stesso argomento per cui le bande si misurano.
 *
 * A banner spento la variabile sparisce e il termine vale `0px`: le riserve si
 * sgonfiano da sole.
 */
export function useAltezzaBandaGara(elemento: HTMLElement | null): void {
  useAltezzaPubblicata(elemento, VARIABILE);
}
